import { useEffect, useState } from "react";

const ExportReportModal = ({ resCode, handleClose,retractionErrMsg = null }) => {
  const [timeLeft, setTimeLeft] = useState(10);

  useEffect(() => {
    if (timeLeft <= 0 && resCode === 200) {
      handleClose();
      return;
    }

    const timerId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft, handleClose]);

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-theme">Report</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              {resCode === 200 ? (
                <>
                  <p className=" mb-4">
                    We have received your request and will email the report as
                    soon as it is generated..
                  </p>
                  <p className=" mb-4">
                    <span className="fw-bolder">Note:</span> Large reports may
                    be delivered in multiple files by year. Thank you!
                  </p>
                </>
              ) : retractionErrMsg?.includes("No Retracted DOIs Currently Found")  ? retractionErrMsg : (
                <div class="card border-0 text-center p-4">
                  <p className="text-danger fs-5 fw-semibold mb-2">
                    Unable to process request
                  </p>
                  <p className="text-muted mb-0">
                    We couldn't submit your report request at this time. Please
                    try again later.
                  </p>
                </div>
              )}

              {/* Footer Buttons */}
              {resCode === 200 && (
                <div className="d-flex justify-content-between gap-2 align-items-center">
                  {
                    <span className="text-danger small me-2">
                      Auto-closing in {timeLeft}s...
                    </span>
                  }
                  <button
                    type="button"
                    className="btn btn-secondary"
                    // onClick={onClose}
                    onClick={handleClose}
                  >
                    Close ({timeLeft})
                  </button>
                </div>
              )}
              {resCode !== 200 && (
                <div className="d-flex justify-content-end gap-2 align-items-center">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    // onClick={onClose}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExportReportModal;
